"use client";

import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Slick Slider settings
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

export function Hero() {
  const slides = [
    {
      image: "/images/hero.jpg",
      heading: "Comprehensive Industry Expertise",
      description:
        "Serving Coatings, Construction, Plastics, Pharmaceuticals, Agriculture, and more with top-tier specialty chemicals.",
    },
    {
      image: "/images/hero1.jpg",
      heading: "Sustainable Impact",
      description:
        "Committed to advancing industries with innovative, eco-friendly, and efficient chemical solutions.",
    },
    {
      image: "/images/hero2.jpg",
      heading: "Tailored Solutions & Support",
      description:
        "Offering custom formulations, technical expertise, and dependable logistics for local and regional manufacturers.",
    },
    {
      image: "/images/hero1.jpg",
      heading: "Industrial Chemicals At Your Door",
      description:
        "Covering markets across Africa, the Middle East, Subcontinent, and Southeast Asia from our head office in RAK-UAE.",
    },
  ];

  return (
    <div className="relative flex items-center justify-center overflow-hidden">
      <div className="w-full mx-auto z-10">
        <Slider {...sliderSettings}>
          {slides.map((slide, index) => (
            <div key={index} className="relative before:absolute before:inset-0 before:bg-[#03345cba] before:opacity-75 w-full h-[650px]">
              <motion.img
                src={slide.image}
                alt={slide.heading}
                className="size-full object-cover"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              />
              <motion.div
                className="text-left text-white absolute right-0 bottom-[12%] pr-4 pb-4 pt-4 sm:pr-8 sm:pb-8 sm:pt-8 max-w-2xl pl-16 sm:pl-20 md:pl-8"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <h1 className="text-[30px] md:text-5xl lg:text-6xl font-bold mb-4 leading-none">
                  {slide.heading}
                </h1>
                <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
                  {slide.description}
                </p>

              </motion.div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="absolute inset-y-0 left-0 bg-[#03345c] w-12 z-30 h-[calc(100%-8px)]">
        <p className="text-white font-Satoshi text-sm font-semibold tracking-[3px] rotate-180 uppercase px-4 py-8 writing-mode-tb-rl flex justify-start h-full items-center w-full">
          Industrial chemicals at your door
        </p>
      </div>
    </div>
  );
}
